var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPilotWeaponsSpecialist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#353d3c;}.cls-3{fill:#03b8ff;}.cls-4{fill:#4d5b5a;}.cls-5{fill:#222625;}.cls-6{fill:#2c8a8c;}.cls-7{fill:#3d9ea5;}.cls-8{fill:#995b0a;}.cls-9{fill:#edbe7e;}.cls-10{fill:#efd2af;}.cls-11{fill:#664624;}.cls-12{fill:#c1e2e5;mix-blend-mode:color-dodge;opacity:0.15;}.cls-13{fill:#0ee0e0;}.cls-14{fill:#2e8c8e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 261.24,
    y: -11.92,
    width: 11,
    height: 63,
    transform: "matrix(-0.81, -0.59, 0.59, -0.81, 470.53, 192.8)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.32 92.03 217.45 -12.12 207.76 -19.2 137.53 76.87 141.32 92.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "248.72 -54.9 172.6 49.24 162.91 42.16 233.13 -53.91 248.72 -54.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15,264.79l63.77,46.62,41.31-56.51-21-15.34L229,62l32.42-.29L312.5-8.28,248.72-54.9ZM288.15-3.78,256.88,39l-53.23-1.74,49-67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "214.55 61.33 57.58 276.07 54.35 273.71 209.55 61.39 214.55 61.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "203.15 61.67 46.18 276.41 42.95 274.05 198.15 61.73 203.15 61.67"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: -8.14,
    y: 219.15,
    width: 102,
    height: 5.62,
    transform: "translate(-161.63 125.58) rotate(-53.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 61.24,
    y: 276.8,
    width: 70,
    height: 8,
    transform: "translate(-187.25 192.79) rotate(-53.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 36.16,
    y: 271.07,
    width: 11,
    height: 40,
    transform: "translate(-217.91 152.94) rotate(-53.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 110.54,
    y: 137.54,
    width: 59.67,
    height: 233.26,
    transform: "translate(-113.79 394.54) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 52,
    y: 191,
    width: 34,
    height: 60,
    transform: "translate(244.23 69.68) rotate(66.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 198.24,
    y: 192.83,
    width: 34,
    height: 60,
    transform: "translate(505.37 114.16) rotate(113.47)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "156.56 51.35 224.36 79.96 244.12 169.64 216 201 193.96 244.76 139.92 272.53 86.04 244.41 66 201 35.88 169.29 55.64 79.6 123.44 51 139.92 62.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "139.91 207.31 203 145.41 174.37 88.83 139.91 104.01 105.63 89.03 77 145.6 139.91 207.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "140.38 220.51 171.35 209.26 169.07 197.63 180 175.66 140.45 153 100.46 175.55 111.39 197.52 109.11 209.15 140.38 220.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "140.25 182.11 126.64 172.5 140.25 169.89 153.86 172.5 140.25 182.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "140.25 199 140.25 199 139.25 180 141.25 180 140.25 199"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "125.21 202.09 122.84 201.13 140.52 196.79 140.9 199.76 125.21 202.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "155.52 202.09 157.9 201.13 140.21 196.79 139.84 199.76 155.52 202.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "134 146 129.15 143 112 142 102 132 124 135 134 146"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "61.26 101.25 52.84 89.16 52.41 75.51 77.36 77.35 61.26 101.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "145.69 146.47 150.54 143.47 167.69 142.47 177.69 132.47 155.69 135.47 145.69 146.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "219.31 101.25 227.74 89.16 228.16 75.51 203.22 77.35 219.31 101.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "257 284 24 284 25.93 136.06 44 52.15 141.25 23 237 52.15 255.06 136.06 257 284"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "54 284 13 284 13 149 26 139 54 284"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "268 284 227 284 255 139 268 149 268 284"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "268 228.41 288.64 239.8 303.85 284 268 284"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "13 228.41 -7.64 239.8 -22.85 284 13 284"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilotWeaponsSpecialist);
export default __webpack_public_path__ + "static/media/pilot-weapons-specialist.c4fad701dbbcbe79641fb2048a8b65dc.svg";
export { ForwardRef as ReactComponent };